import { QRCodeSVG } from 'qrcode.react';

interface QRCodeDisplayProps {
  value: string;
  size?: number;
}

export const QRCodeDisplay = ({ value, size = 256 }: QRCodeDisplayProps) => {
  return (
    <div className="flex justify-center">
      <QRCodeSVG
        value={value}
        size={size}
        level="H"
        includeMargin
        bgColor="#ffffff"
        fgColor="#000000"
      />
    </div>
  );
};
